import api from "../utils/axiosInstance";
const API_BASE = process.env.REACT_APP_API_BASE_URL;

export const createQuery = async (createdBy, question) => {
  const res = null;
  const token = localStorage.getItem("token");

  const response = await api.post(
    `${API_BASE}/api/v1/communication/create`,
    null,
    {
      params: { createdBy, question },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return {
    success: true,
    message: "Success",
    data: response.data,
  };
};

export const answerQuery = async (messageId, answer) => {
  const res = null;
  const token = localStorage.getItem("token");
  const response = await api.post(
    `${API_BASE}/api/v1/communication/answer`,
    null,
    {
      params: { messageId, answer },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (response.status == 200) {
    return {
      success: true,
      message: "Success",
      data: response.data,
    };
  } else {
    return {
      success: false,
      message: "Failed, Please try again.",
      data: null,
    };
  }
};

export const getMyMessages = async () => {
  const token = localStorage.getItem("token");
  const apiUrl = `${API_BASE}/api/v1/communication/list`;

  try {
    const response = await api.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return {
      result: "success",
      message: "Success",
      data: response.data.data,
    };
  } catch (error) {
    return {
      result: "error",
      message: "Something went wrong, please try again !",
      data: null,
    };
  }
};
